import * as React from "react";
import {Col, Row} from "react-bootstrap";
import dateFormat from "dateformat";
import Information from "../models/Information";
import $ from 'jquery'
import {useEffect, useState} from "react";
import ContentLoader from "react-content-loader";

const InformationPanel : React.FC<Information> = ({id, date, title, content}) => {
    const _date = new Date(date);
    dateFormat.i18n.dayNames = ['日','月','火', '水', '木', '金', '土', '日','月','火', '水', '木', '金', '土'];
    const formatedDate = dateFormat(_date, 'yyyy/mm/dd(ddd)');
    return (
        <a className={"infomation-link"} href={`/information/${id}.html`}>
            <Row>
                <Col xs={12} md={3} className={"date"}>[{formatedDate}]</Col>
                <Col><h2>{title}</h2></Col>
            </Row>
            <Row>
                <Col className={"detail"}>
                    詳細を見る
                </Col>
            </Row>
        </a>
    );
}

const InformationList : React.FC = () => {
    const [info, setInformation] = useState<Information[]>([]);
    const [loadend, setLoadEnd] = useState(false);

    useEffect(() => {
        $.ajax('/api/', {
            type: 'get',
        }).done((data) => {
            const m: Information[] = data;
            setInformation(m);
        }).fail((error) => {
        }).always(() => {
            setLoadEnd(true);
        });
    }, [])

    if (!loadend) {
        return (
            <div className={"information"}>
                <h1>お知らせ</h1>
                <ContentLoader viewBox={"0 0 300 35"}>
                    {/* @ts-expect-error Async Server Component */}
                    <rect x={"0"} y={"0"} rx={"5"} ry={"5"} width={"300"} height={"35"}/>
                </ContentLoader>
            </div>
        );
    }

    if (info.length === 0) {
        return (
            <div className={"information"}>
                <h1>お知らせ</h1>
                <div style={{paddingLeft: "20px"}}>現在のお知らせはありません。</div>
            </div>
        );
    }

    return (
        <div className={"information"}>
            <h1>お知らせ</h1>
            {info.map(m => (
                <InformationPanel key={m.id} {...m} />
            ))}
        </div>
    );
}

export default InformationList;
